import { List, Modal, Skeleton } from 'antd';
import React, { useRef } from 'react';
import "./AdminLayout.css";

interface GroupEmployeeList {
    closePopup: () => void;
    listData: string[]
  }
const GroupEmployeeList: React.FC<GroupEmployeeList> = ({
        closePopup, listData
      }) => {
    return <>
     <Modal maskClosable={false} title="Employee List" open={true} onCancel={() => closePopup()} 
      style={{marginTop: 60}}
      footer={null} 
      width={600}>
        <List
                      size="small"
                      className="demo-loadmore-list"
                      itemLayout="horizontal"
                      dataSource={listData}
                      renderItem={(item: any, index) => (
                        <List.Item
                        
                        >
                          <Skeleton
                            avatar
                            title={false}
                            loading={item.loading}
                            active
                          >
                            <List.Item.Meta title={item} />

                          </Skeleton>
                        </List.Item>
                      )}
                    />

  
      </Modal>
    </>
}

export default GroupEmployeeList;

